/* import __COLOCATED_TEMPLATE__ from './price-breakdown-display.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();